import styled from 'styled-components'
import { PeopleEdit } from '@styled-icons/fluentui-system-regular/PeopleEdit'
import { ViewShow } from '@styled-icons/zondicons/ViewShow'
import PageActionWrapper from '../PageActionWrapper'

export const PageWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const StyledPageActionWrapper = styled(PageActionWrapper)`
  margin: var(--bq-spacing-l) 0;
  @media screen and (max-width: 1395px) {
    margin: var(--bq-spacing-xs) 0;
  }
`

export const TableWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  overflow-x: auto;
`

export const EditIcon = styled(PeopleEdit)`
  color: ${(props) => (props.disabled ? '#808080' : '#1890ff')};
`

export const ViewIcon = styled(ViewShow)`
  color: #1890ff;
`
export const StyledWarningTitle = styled.span`
  display: flex;
  gap: var(--bq-spacing-xs);
  align-items: center;
`

export const StyledWarningFooter = styled.footer`
  display: flex;
  justift-content: flex-end;
  gap: var(--bq-spacing-xs);
`
